import { piqureWrapper } from 'piqure';

const { provideLazy, inject } = piqureWrapper(globalThis, 'piqure.authentication');

export { provideLazy, inject };
